import { Component, OnInit } from '@angular/core';
import { ResourceAccessService, ResourcePlanningAccess } from '../../../Services/resource-access.service';

interface CatalogScope {
  /** null = globaler Katalog. */
  teamId: number | null;
  label: string;
  canEdit: boolean;
}

/**
 * Skills & Kategorien: oben der Verwaltungsbereich (Global bzw. berechtigte Teams),
 * darunter Skills und Kategorien dieses Bereichs. Neue Einträge entstehen immer im
 * gewählten Bereich.
 */
@Component({
  selector: 'app-resource-verwaltung',
  templateUrl: './resource-verwaltung.component.html',
  styleUrls: ['./resource-verwaltung.component.css']
})
export class ResourceVerwaltungComponent implements OnInit {
  loading = true;
  error = '';
  scopes: CatalogScope[] = [];
  selected: CatalogScope | null = null;

  constructor(private accessApi: ResourceAccessService) { }

  ngOnInit(): void {
    this.accessApi.getMine().subscribe({
      next: access => {
        this.scopes = this.buildScopes(access);
        // Startauswahl einmalig nach gemeinsamer Regel: eigenes Hauptteam vor „Global“.
        const startTeamId = ResourceAccessService.defaultTeamId(
          access, access.catalogTeams.map(t => t.teamId), access.canManageGlobalCatalog);
        this.selected = this.scopes.find(s => s.teamId === startTeamId) ?? this.scopes[0] ?? null;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.error = 'Berechtigungen konnten nicht geladen werden.';
      }
    });
  }

  selectScope(teamId: number | null): void {
    this.selected = this.scopes.find(s => s.teamId === teamId) ?? this.selected;
  }

  private buildScopes(access: ResourcePlanningAccess): CatalogScope[] {
    const scopes: CatalogScope[] = [];
    // Globaler Katalog nur für SuperAdmin (Kaufmännisch verwaltet ausschließlich Teamkataloge).
    if (access.canManageGlobalCatalog) {
      scopes.push({ teamId: null, label: 'Global', canEdit: true });
    }
    for (const team of access.catalogTeams) {
      scopes.push({ teamId: team.teamId, label: team.teamName, canEdit: true });
    }
    return scopes;
  }
}
